var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 2.00002C4.68662 2.00002 2.00033 4.68631 2.00033 8.00002C2.00033 11.3137 4.68662 14 8.00033 14C11.314 14 14.0003 11.3137 14.0003 8.00002C14.0003 4.68631 11.314 2.00002 8.00033 2.00002ZM0.666992 8.00002C0.666992 3.94993 3.95024 0.666687 8.00033 0.666687C12.0504 0.666687 15.3337 3.94993 15.3337 8.00002C15.3337 12.0501 12.0504 15.3334 8.00033 15.3334C3.95024 15.3334 0.666992 12.0501 0.666992 8.00002Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 7.33331C8.36786 7.33331 8.66634 7.63179 8.66634 7.99998V10.6666C8.66634 11.0348 8.36786 11.3333 7.99967 11.3333C7.63148 11.3333 7.33301 11.0348 7.33301 10.6666V7.99998C7.33301 7.63179 7.63148 7.33331 7.99967 7.33331Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 5.33335C7.33301 4.96516 7.63148 4.66669 7.99967 4.66669H8.00634C8.37453 4.66669 8.67301 4.96516 8.67301 5.33335C8.67301 5.70154 8.37453 6.00002 8.00634 6.00002H7.99967C7.63148 6.00002 7.33301 5.70154 7.33301 5.33335Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/information.da4ebd4912f111b8ff24110d66d48223.svg";